import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectHousingFinanceAgencies = createSelector(
  [selectLoanApplication],
  ({ housingFinanceAgencies }) => housingFinanceAgencies,
);

export const selectHousingFinanceAgenciesOptions = createSelector(
  [selectHousingFinanceAgencies],
  housingFinanceAgencies =>
    housingFinanceAgencies.map(agency => ({
      name: agency.name,
      value: agency.id,
      isOther: agency.level?.type === 'Other',
    })),
);
